import { createContext, useContext } from 'react';

export type LineBulkEditTargets = (originId: string) => readonly string[];

const LineBulkEditContext = createContext<LineBulkEditTargets | null>(null);

export const LineBulkEditProvider = LineBulkEditContext.Provider;

export function useLineBulkEditTargets(): LineBulkEditTargets {
  const value = useContext(LineBulkEditContext);
  return value ?? ((originId: string) => [originId]);
}
